import React, {PropTypes} from "react";
import Button from "react-bootstrap/lib/Button";
import moment from "moment";
import axios from "axios";
import toastr from "toastr";
import CircularProgress from "material-ui/CircularProgress";

let cleanString = (string) => {
  return string.replace(/"/g, "");
};

let cleanStringArray = (arrayOfStrings) => {
  for (let i = 0; i < arrayOfStrings.length; i++) {
    arrayOfStrings[i] = cleanString(arrayOfStrings[i]);
  }
  return arrayOfStrings
};
function validate(csv) {
  let row = csv.split('\n');
  let header = row[0].split(',');
  header = cleanStringArray(header);
  header = header.map((element) => {
    return element.split(' ').join('').toLowerCase();
  });
  return true;
}
function csvJSON(csv) {

  var lines = csv.split("\n");

  var result = [];

  var headers = lines[0].split(",");

  for (var i = 1; i < lines.length ; i++) {

    var obj = {};
    var currentline = lines[i].split(",");

    if (currentline[0] == "") {
      debugger;
      currentline[0] = null;
    }
    var date = new Date();
    for (var j = 0; j < headers.length; j++) {
      try {
        if (typeof(currentline[j]) == 'string')
          currentline[j] = currentline[j].trim();
        else
          currentline[j] = null;
        switch (j) {
          case 0:
            obj['empId'] = currentline[0];
            break;
          case 1:
            obj['date'] = moment(currentline[1], 'DD-MM-YYYY');
            if (!moment(obj['date']).isValid())
              obj['date'] = null;
            else
              obj['date'] = moment(currentline[1], 'DD-MM-YYYY').format('YYYY-MM-DD');
            break;
          case 2:
            if (typeof(currentline[2]) == 'string') {
              // check that string is from 00:00 to 23:59 only
              let isValid = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(currentline[2].trim());
              if (currentline[2].trim().length == 0 || !isValid)
                obj['inTime'] = null;
              else
                obj['inTime'] = currentline[2].trim()  + ":00";
            }
            else
              obj['inTime'] = null;
            break;
          case 3:
            if (typeof(currentline[3]) == 'string') {
              // check that string is from 00:00 to 23:59 only
              let isValid = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(currentline[3].trim());
              if (currentline[3].trim().length == 0 || !isValid)
                obj['outTime'] = null;
              else
                obj['outTime'] = currentline[3].trim()  + ":00";
            }
            else
              obj['outTime'] = null;
            break;
        }
      }
      catch (error) {
        toastr.error("Parse Error Occurred");
      }
    }

    result.push(obj);

  }

  //return result; //JavaScript object
  return result; //JSON
}
class AttendanceUpload extends React.Component {

  constructor() {
    super();
    this.state = {
      value: "",
      disabled: false,
      length: 0,
      uploaded: [],
      requestObject: [],
      completed: false,
      uploading: false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    let files = event.target.files;
    if (files.length === 1) {
      let reader = new FileReader();
      reader.onload = function () {
        let csv = reader.result;
        if (validate(csv) === true) {

          let result = (csvJSON(csv));
          console.log(result);
          console.log(result[0]);
          this.setState({requestObject: result, length: result.length})
        }
        else {
          alert("Please check the table format of the csv uploaded.")
        }
      }.bind(this);
      this.setState({value: event.target.value})
      reader.readAsText(files[0], 'UTF-8');
    }
  }

  render() {
    return (
      <div>
        <div>
          <div role="tabpanel" className="tab-pane" id="apply">
            <div className="row clearfix">
              <div className="inner-col-wrap inner-table-wrap ">

                <div className="col-md-12" style={{margin: 0, padding: 0}}>
                  <div className="col-md-12">

                    <form>
                      <a style={{marginLeft: '90%'}} download={true} href="/public/attendanceUploadSample.csv">Download
                        Sample</a>
                      <input disabled={this.state.disabled}
                             value={this.state.value}
                             type="file" accept=".csv" name="file" onChange={this.handleChange}/>

                      <br/>
                      {this.state.value != "" ? <Button
                        disabled={this.state.disabled}
                        style={{marginRight: '20px'}} onClick={()=> {
                        this.setState({disabled: true, uploading: true});

                        let requestObject = this.state.requestObject;
                        requestObject.filter((node)=> {
                          if (node == null || node.empId == null)
                            return false;
                        })
                        console.log(requestObject);
                        axios.post(process.env.REQ_URL + "/attendance/saveAttendance", {data: requestObject}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                          if (response.data.data.message == false) {
                            toastr.error("Error Occurred");
                            this.setState({requestObject: [], completed: false, uploading: false});
                          }
                          else
                          if (response.data.data.status == false) {
                            toastr.error(response.data.data.message);
                            this.setState({requestObject: [], completed: false, uploading: false});
                          }else
                            this.setState({requestObject: response.data.data, completed: true, uploading: false});

                        }).catch((error)=> {
                          this.setState({uploading: false})

                          toastr.error("error ");

                        });

                      }}>Upload</Button> : null}

                      <Button
                        onClick={()=> {
                          this.setState({value: "", disabled: false, requestObject: [], uploaded: [], completed: false})
                        }}>Reset</Button>
                    </form>

                    {this.state.value != "" ? this.state.length + " Records Found" : null}

                    {this.state.completed ? <h4>UPLOAD COMPLETE</h4> : null}
                    {this.state.uploading ? <CircularProgress /> : null}


                    <br/>
                    <nav style={{borderStyle: 'solid'}}>
                      <br/>
                      <ul style={{'overflow': 'hidden', 'overflowY': 'scroll', height: '300px', width: '100%'}}>
                        <table className="table table-bordered">
                          <thead>
                          <tr>
                            <th>Id</th>
                            <th>EmpId</th>
                            <th>Date</th>
                            <th>InTime</th>
                            <th>OutTime</th>
                            <th>Log</th>
                          </tr>
                          </thead>

                          <tbody>
                          {this.state.requestObject.map((node, index)=> {
                            return <tr>
                              <td>{node.id}</td>
                              <td>{node.empId}</td>
                              <td>{node.date ? node.date : null} </td>
                              <td> {node.inTime}</td>
                              <td>{node.outTime}</td>
                              <td>{node.message}</td>
                            </tr>

                          })}
                          </tbody>
                        </table>
                      </ul>
                    </nav>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AttendanceUpload.propTypes = {};

export default AttendanceUpload;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/AttendanceUpload/AttendanceUpload.js
 **/